/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tld_Pricing_No_Match_BodyInputs */

const id_tld_pricing_no_match_body = /** @type {(inputs: Tld_Pricing_No_Match_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ubah pencarian atau saringannya.`)
};

const en_tld_pricing_no_match_body = /** @type {(inputs: Tld_Pricing_No_Match_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change the search or the filters.`)
};

/**
* | output |
* | --- |
* | "Change the search or the filters." |
*
* @param {Tld_Pricing_No_Match_BodyInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const tld_pricing_no_match_body = /** @type {((inputs?: Tld_Pricing_No_Match_BodyInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tld_Pricing_No_Match_BodyInputs, { locale?: "id" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tld_pricing_no_match_body(inputs)
	return id_tld_pricing_no_match_body(inputs)
});